module.exports = "<div class=\"sis-column-sortable test-selenium-column-sortable\" (click)=\"sort()\">\n    <ng-content></ng-content>\n</div>";